<template>
  <v-app v-if="isLogin">
    <!-- ヘッダー -->
    <header class="header">
      <div class="header-left">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="toggleSidebar" v-bind="attrs" v-on="on">
              <i class="fas fa-bars menu-toggle"></i>
            </v-btn>
          </template>
          <span v-if="sidebarOpen">メニュー非表示</span>
          <span v-else>メニュー表示</span>
        </v-tooltip>
        <div class="logo">
          <i class="fas fa-shield-alt"></i>
          調整システム
        </div>
      </div>
      <div class="header-center">
        <span>災害名称：</span>
        <select
          class="header-disaster"
          :value="disasterFilter"
          @change="onChangeDisaster"
        >
          <option v-if="isAuth || !disasterFilter" value=""
            >災害名称を選択してください</option
          >
          <option
            v-for="data in disasterList"
            :key="data.disaster_no"
            :value="data.disaster_no"
            >{{ data.disaster_name }}</option
          >
        </select>
      </div>
      <div class="header-right">
        <div class="user-info">
          <i class="fas fa-user-circle"></i>
          <span>{{ userName }}</span>
        </div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="logout()" v-bind="attrs" v-on="on">
              <i class="fas fa-sign-out-alt icon-logout"></i>
            </v-btn>
          </template>
          <span>ログアウトする</span>
        </v-tooltip>
      </div>
    </header>

    <!-- 左メニュー -->
    <nav
      class="sidebar"
      :class="{ collapsed: !sidebarOpen, 'mobile-open': sidebarOpen }"
    >
      <div class="nav-menu">
        <div class="nav-section">
          <i class="fas fa-list"></i>
          自治会の調整
          <v-btn
            class="btn-secondary"
            style="font-size: 12px;"
            @click="clickClearLog"
            v-if="isAuth && isClickClearLog"
          >
            進行状況<br />非表示
          </v-btn>
        </div>
        <a
          href="#"
          class="nav-item"
          :class="{ active: activeItem === 'damage_situation' }"
          @click="setActiveItem('damage_situation')"
        >
          <i class="fas fa-building"></i>
          受入市町の被災状況確認
          <i class="fas fa-circle" style="color:red;" v-if="isStatusDS"></i>
        </a>

        <a
          href="#"
          class="nav-item"
          :class="{ active: activeItem === 'evacuation_target' }"
          @click="setActiveItem('evacuation_target')"
        >
          <i class="fas fa-users"></i>
          避難対象の自治会確認
          <i class="fas fa-circle" style="color:red;" v-if="isStatusET"></i>
        </a>

        <a
          href="#"
          class="nav-item"
          :class="{ active: activeItem === 'temporary_registration' }"
          @click="setActiveItem('temporary_registration')"
          v-if="isAuth"
        >
          <i class="fas fa-check-square"></i>
          代替避難所の仮登録
          <i class="fas fa-circle" style="color:red;" v-if="isStatusTR"></i>
        </a>

        <a
          href="#"
          class="nav-item"
          :class="{ active: activeItem === 'confirmation_eva' }"
          @click="setActiveItemWithStep('confirmation_eva', 1)"
        >
          <i class="fas fa-check-circle"></i>
          代替避難所の確定
        </a>
        <a
          href="#"
          class="nav-item nav-subitem"
          :class="{
            active: activeItem === 'confirmation_eva' && currentStep === 1
          }"
          @click="setActiveItemWithStep('confirmation_eva', 1)"
        >
          <div class="step-number" style="width:18px; height:18px;">1</div>
          受入先市町の受入可否の確認
          <i class="fas fa-circle" style="color:red;" v-if="isStatusCE1"></i>
        </a>
        <a
          href="#"
          class="nav-item nav-subitem"
          :class="{
            active: activeItem === 'confirmation_eva' && currentStep === 2
          }"
          @click="setActiveItemWithStep('confirmation_eva', 2)"
        >
          <div class="step-number" style="width:18px; height:18px;">2</div>
          避難元市町の代替避難先の確認
          <i class="fas fa-circle" style="color:red;" v-if="isStatusCE2"></i>
        </a>
        <a
          href="#"
          class="nav-item nav-subitem"
          :class="{
            active: activeItem === 'confirmation_eva' && currentStep === 3
          }"
          @click="setActiveItemWithStep('confirmation_eva', 3)"
          v-if="isAuth"
        >
          <div class="step step-number" style="width:18px; height:18px;">3</div>
          県の確認
          <i class="fas fa-circle" style="color:red;" v-if="isStatusCE3"></i>
        </a>

        <div v-if="isAuth">
          <div class="nav-section">
            <i class="fas fa-list"></i>
            医療機関等の調整
          </div>
          <a
            href="#"
            class="nav-item"
            :class="{ active: activeItem === 'evacuation_target_vul' }"
            @click="setActiveItem('evacuation_target_vul')"
          >
            <i class="far fa-hospital"></i>
            避難対象の医療機関等確認
          </a>

          <a
            href="#"
            class="nav-item"
            :class="{ active: activeItem === 'temporary_registration_vul' }"
            @click="setActiveItem('temporary_registration_vul')"
            v-if="isAuth"
          >
            <i class="far fa-check-square"></i>
            代替医療機関等の仮登録
          </a>

          <a
            href="#"
            class="nav-item"
            :class="{ active: activeItem === 'confirmation_vul' }"
            @click="setActiveItem('confirmation_vul')"
          >
            <i class="far fa-check-circle"></i>
            代替医療機関等の確定
          </a>
        </div>

        <div v-if="isAuth">
          <div class="nav-section">
            <i class="fas fa-list"></i>
            検索
          </div>
          <a
            href="#"
            class="nav-item"
            :class="{ active: activeItem === 'monitoring_post' }"
            @click="setActiveItem('monitoring_post')"
            v-if="isAuth"
          >
            <i class="fas fa-magnifying-glass"></i>
            モニタリングポスト
          </a>

          <a
            href="#"
            class="nav-item"
            :class="{ active: activeItem === 'facility_search_eva' }"
            @click="setActiveItem('facility_search_eva')"
            v-if="isAuth"
          >
            <i class="fas fa-magnifying-glass"></i>
            避難元避難先(避難所)
          </a>

          <a
            href="#"
            class="nav-item"
            :class="{ active: activeItem === 'facility_search_vul' }"
            @click="setActiveItem('facility_search_vul')"
            v-if="isAuth"
          >
            <i class="fas fa-magnifying-glass"></i>
            避難元避難先(医療機関等)
          </a>
        </div>
      </div>
    </nav>

    <!-- メインコンテンツ -->
    <main class="main-content" :class="{ expanded: !sidebarOpen }">
      <component
        :is="currentComponent"
        :disaster-no="disasterFilter"
        :received-step="currentStep"
        :key="disasterFilter"
        @update-status="handleStatusUpdate"
        @change-step="handleStepChange"
      />
    </main>
    <ConfirmDialog ref="confirmDialog" />
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-app>
  <v-app v-else>
    <v-main>
      <v-container>
        <v-alert type="warning">
          {{ alertMsg }}
        </v-alert>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import "@/css/styles_adjustment_system.css";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { ScreenId } from "@/js/value-objects/screen-id";
import { ErrorTodoMessages } from "@/js/constants/error-messages";
import cognito from "@/js/cognito";
import DamageSituation from "@/views/DamageSituation";
import EvacuationTarget from "@/views/EvacuationTarget";
import TemporaryRegistration from "@/views/TemporaryRegistration";
import ConfirmationEva from "@/views/ConfirmationEva";
import EvacuationTargetVul from "@/views/EvacuationTargetVul";
import TemporaryRegistrationVul from "@/views/TemporaryRegistrationVul";
import ConfirmationVul from "@/views/ConfirmationVul";
import MonitoringPost from "@/views/MonitoringPost";
import FacilitySearchEva from "@/views/FacilitySearchEva";
import FacilitySearchVul from "@/views/FacilitySearchVul";

const adjustmentSystemRepository = RepositoryFactory.get("adjustmentSystem");
const DEFAULT_ITEM = "damage_situation";

export default {
  name: "AdjustmentSystem",
  data: () => ({
    overlay: false,
    sidebarOpen: false,
    activeItem: "",
    currentStep: 1,
    userName: "",
    isAuth: false,
    isLogin: false,
    alertMsg: "",
    disasterList: [],
    disasterFilter: "",
    isClickClearLog: false,
    isStatusDS: false,
    isStatusET: false,
    isStatusTR: false,
    isStatusCE1: false,
    isStatusCE2: false,
    isStatusCE3: false
  }),
  computed: {
    currentComponent() {
      const components = {
        damage_situation: "DamageSituation",
        evacuation_target: "EvacuationTarget",
        temporary_registration: "TemporaryRegistration",
        confirmation_eva: "ConfirmationEva",
        evacuation_target_vul: "EvacuationTargetVul",
        temporary_registration_vul: "TemporaryRegistrationVul",
        confirmation_vul: "ConfirmationVul",
        monitoring_post: "MonitoringPost",
        facility_search_eva: "FacilitySearchEva",
        facility_search_vul: "FacilitySearchVul"
      };
      return components[this.activeItem];
    }
  },
  components: {
    ConfirmDialog: () => import("@/components/adjustment/AdConfirmDialog"),
    DamageSituation,
    EvacuationTarget,
    TemporaryRegistration,
    ConfirmationEva,
    EvacuationTargetVul,
    TemporaryRegistrationVul,
    ConfirmationVul,
    MonitoringPost,
    FacilitySearchEva,
    FacilitySearchVul
  },
  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      this.overlay = true;
      try {
        await this.isAuthCheck();
        if (this.isLogin) {
          /* 調整システム初期情報取得 */
          const payload = {
            disasterNo: this.$disaster.disaster_no,
            disasterFlg: true
          };

          await adjustmentSystemRepository
            .list(ScreenId.SF4101, payload)
            .then(response => {
              this.sidebarOpen = true;
              this.userName = response.data.userName;
              this.isAuth = response.data.isAuth;
              this.activeItem = DEFAULT_ITEM;
              this.disasterList = response.data.disasterList;
              this.disasterFilter = this.$disaster.disaster_no;

              this.isClickClearLog = response.data.isProgress;
              this.isStatusDS = response.data.progressList[0].isStatusDS;
              this.isStatusET = response.data.progressList[0].isStatusET;
              this.isStatusTR = response.data.progressList[0].isStatusTR;
              this.isStatusCE1 = response.data.progressList[0].isStatusCE1;
              this.isStatusCE2 = response.data.progressList[0].isStatusCE2;
              this.isStatusCE3 = response.data.progressList[0].isStatusCE3;
            })
            .catch(e => {
              this.handleUpdateError(e);
            });
        }
      } catch (error) {
        this.handleUpdateError(error);
        console.error("調整システムの初期処理に失敗しました:", error);
      } finally {
        this.overlay = false;
      }
    },
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
    async setActiveItem(item) {
      await this.isAuthCheck();
      if (this.isLogin) this.activeItem = item;
    },
    async setActiveItemWithStep(item, step) {
      await this.isAuthCheck();
      if (this.isLogin) {
        this.activeItem = item;
        this.currentStep = step;
      }
    },
    async isAuthCheck() {
      try {
        // cognitoでログイン情報をチェック
        await cognito.isAuthenticated();

        // ログイン状態とする
        this.isLogin = true;
      } catch (error) {
        this.isLogin = false;
        this.alertMsg = ErrorTodoMessages.ERWE48007;
      }
    },
    logout() {
      cognito.logout();
      this.isLogin = false;
      this.alertMsg = "ログアウトしました。画面を閉じてください。";
    },
    async onChangeDisaster(event) {
      const newValue = event.target.value;
      const result = await this.$refs.confirmDialog.open(
        "災害名称を変更します。よろしいですか？",
        "はい"
      );
      if (result) {
        this.disasterFilter = newValue;
      } else {
        event.target.value = this.disasterFilter;
      }
    },
    handleStatusUpdate(payload) {
      switch (payload.menu) {
        case "damage_situation":
          this.isStatusDS = payload.completed;
          break;
        case "evacuation_target":
          this.isStatusET = payload.completed;
          break;
        case "temporary_registration":
          this.isStatusTR = payload.completed;
          break;
        case "confirmation_eva_1":
          this.isStatusCE1 = payload.completed;
          break;
        case "confirmation_eva_2":
          this.isStatusCE2 = payload.completed;
          break;
        case "confirmation_eva_3":
          this.isStatusCE3 = payload.completed;
          break;
      }
      this.isClickClearLog = payload.completed;
    },
    handleStepChange(step) {
      this.currentStep = step;
    },
    async clickClearLog() {
      this.overlay = true;
      try {
        // 確認ダイアログを表示
        const message = "進行状況を非表示にします。よろしいですか？";
        const result = await this.$refs.confirmDialog.open(message, "はい");
        if (!result) {
          return false;
        }

        /* 調整操作履歴削除 */
        const payload = {
          disasterNo: this.$disaster.disaster_no,
          disasterFlg: true
        };

        await adjustmentSystemRepository
          .update(ScreenId.SF4101, payload)
          .then(() => {
            this.isClickClearLog = false;
            this.isStatusDS = false;
            this.isStatusET = false;
            this.isStatusTR = false;
            this.isStatusCE1 = false;
            this.isStatusCE2 = false;
            this.isStatusCE3 = false;
          })
          .catch(e => {
            this.handleUpdateError(e);
          });
      } catch (error) {
        this.handleUpdateError(error);
        console.error("進行状況の非表示に失敗しました:", error);
      } finally {
        this.overlay = false;
      }
    }
  }
};
</script>
